export const hrConfig = {
  employeeName: {
    label: 'Employee Name',
    type: 'text',
    readOnly: true,
  },
  employeeEmail: {
    label: 'Employee Email',
    type: 'text',
    readOnly: true,
  },
  doctorLocationGrouping: {
    label: 'Doctor Location Grouping',
    type: 'text',
    rules: [{ max: 255, message: 'Doctor Location Grouping cannot exceed 255 characters' }],
  },
  stipend: {
    label: 'Stipend',
    type: 'checkbox',
  },
  pathways: {
    label: 'Pathways',
    type: 'checkbox',
  },
  tuitionReimbursement: {
    label: 'Tuition Reimbursement',
    type: 'checkbox',
  },
};
